import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import type { RootState } from "..";

const selectEnergyForecast = (state: RootState) => state.energyForecast;

const selectEnergyForecastAvailability = createSelector(
  [selectEnergyForecast],
  (energyForecast) => energyForecast.availability,
);

const selectEnergyForecastIsLoading = createSelector(
  [selectEnergyForecast],
  (energyForecast) => energyForecast.isLoading,
);

export const useEnergyForecastAvailability = () => useSelector(selectEnergyForecastAvailability);
export const useEnergyForecastIsLoading = () => useSelector(selectEnergyForecastIsLoading);
